export default __webpack_public_path__ + "static/media/NotoSans-Regular.9a4a44bc.woff2";